import { Box, Paper } from "@mui/material";
import FormComponent from "../../components/global/FormComponent";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import Error404 from "../../pages/Error404";
import secureLocalStorage from "react-secure-storage";

const formConfig = [
  {
    field: {
      type: "text",
      title: "Name",
      id: "name",
      name: "name",
      placeholder: "Your Name",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Name is required",
      },
    },
  },
  {
    field: {
      type: "text",
      title: "User Name",
      id: "username",
      name: "username",
      placeholder: "Your User Name",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Name is required",
      },
    },
  },
  {
    field: {
      type: "email",
      title: "Email",
      id: "email",
      name: "email",
      placeholder: "Your Email",
      required: true,
      error: {
        condition: (value) => !/^\S+@\S+\.\S+$/.test(value),
        message: "Invalid email format",
      },
    },
  },
  {
    field: {
      type: "password",
      title: "New Password",
      id: "password",
      name: "password",
      placeholder: "Your Password",
      required: true,
      error: {
        condition: (value) => value === "" || (value && value.length < 8),
        message: "Password should be at least 8 characters long",
      },
    },
  },
  {
    field: {
      type: "password",
      title: "Confirm Password",
      id: "confirmPassword",
      name: "confirmPassword",
      placeholder: "Your Password",
      required: true,
      error: {
        condition: (value) => value === "",
        message: "Confirm password is required",
      },
    },
  },
];
const addFields = {
  confirmPassword: "",
};

const EditProfile = ({ role }) => {
  const { state } = useLocation();
  const { profileData } = state || {};

  console.log("Profile Data", profileData);

  const updateProfileData = { ...profileData, ...addFields };
  const navigate = useNavigate();

  const handleAddOrUpdate = async (formData) => {
    if (formData && formData.password === formData.confirmPassword) {
      try {
        // Make a POST request to the backend endpoint
        const response = await axios.post(
          "http://127.0.0.1:8000/user/update-account",
          formData
        );
        if (response.status === 200) {
          // Handle successful creation of user
          const userData = JSON.parse(response.data.user)[0].fields;
          secureLocalStorage.setItem("userInfo", JSON.stringify(userData));
          navigate(-1);
        } else {
          // Handle other status codes or errors
          console.error("Error:", response.data);
          // Display an error message to the user
        }
      } catch (error) {
        console.error("Error:", error);
        // Handle network errors or other exceptions
        // Display an error message to the user
      }
    } else {
      toast.error();
      Swal.fire({
        icon: "error",
        title: "Passwords do not match",
        text: "Please make sure the new and confirm passwords are the same.",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        style: {
          backgroundColor: "var(--color-black)",
        },
      });
    }
  };

  return (
    <>
      {role === "admin" ? (
        <Box m={"2vw"}>
          <Paper
            style={{
              background: "#222222ed", //rgb(8 6 17 / 27%)"
              padding: "2vh 2vw",
              width: "75%",
              margin: "auto",
            }}
          >
            <FormComponent
              formTitle="Edit Profile Detail"
              formConfig={formConfig}
              buttonText={"Edit Now"}
              handleAddOrUpdate={handleAddOrUpdate}
              fieldValue={updateProfileData}
            />
          </Paper>
          <Toaster position="top-right" />
        </Box>
      ) : (
        <Error404 />
      )}
    </>
  );
};

export default EditProfile;
